/** @jsxImportSource @emotion/react */
import { ThemeProvider as EmotionThemeProvider } from "@emotion/react";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { AppProvider } from "./providers/app";
import { pink, theme } from "./theme";

<link
  rel="stylesheet"
  href="https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap"
/>;
<link
  rel="stylesheet"
  href="https://fonts.googleapis.com/icon?family=Material+Icons"
/>;

function App() {
  return (
    <ThemeProvider theme={theme}>
      <EmotionThemeProvider theme={pink}>
        <CssBaseline />
        <AppProvider />
      </EmotionThemeProvider>
    </ThemeProvider>
  );
}

export default App;
